import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedQuery } from "hooks";
import { BackordersDashboardQueryKeys } from "modules/BackordersDashboard/queryKeys";
import { BACKORDERS_STORAGE_KEYS } from "modules/BackordersDashboard/storageKeys";
import { REG_VIN_FILTER } from "modules/WarrantyDashboard/hooks";
import { PAGE_SIZE, getPreference } from "utils/common";

import type { DealerLocation } from "models";
import type { BackordersDashboardFilters } from "modules/BackordersDashboard/queryKeys";
import type { AtLeastOne } from "utils/type";

export const setBackordersDashboardFilters = (filters: AtLeastOne<BackordersDashboardFilters>) =>
  typedQueryClient.setQueryData(BackordersDashboardQueryKeys.filters, prev => (prev ? { ...prev, ...filters } : prev));

const getDefaultBackordersDashboardFilters = (selectedLocation?: DealerLocation | null): BackordersDashboardFilters => ({
  dealer_ids: getPreference(BACKORDERS_STORAGE_KEYS.DealerPreference, []),
  location_ids: getPreference(BACKORDERS_STORAGE_KEYS.LocationPreference, selectedLocation ? [selectedLocation.id] : []),
  page: 1,
  search_term: "",
  appointment_date_from: getPreference(BACKORDERS_STORAGE_KEYS.AppointmentDateFromPreference, null),
  appointment_date_to: getPreference(BACKORDERS_STORAGE_KEYS.AppointmentDateToPreference, null),
  backorder_date_from: getPreference(BACKORDERS_STORAGE_KEYS.DateFromPreference, null),
  backorder_date_to: getPreference(BACKORDERS_STORAGE_KEYS.DateToPreference, null),
  page_size: getPreference(BACKORDERS_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25),
  reg_vin_filter: getPreference(BACKORDERS_STORAGE_KEYS.RegVinPreference, REG_VIN_FILTER.Reg)
});

export const useBackordersDashboardFilters = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedQuery({ queryKey: BackordersDashboardQueryKeys.filters, initialData: () => getDefaultBackordersDashboardFilters(selectedLocation) }).data;
};
